import dayjs from "dayjs";
import { dateFormatList } from "../../utils/constants";
import { Box } from "@mui/material";
import {
  CalendarComponent,
  CalendarWrapper,
  NotificationCalendarStyle,
  StyledDatePicker,
} from "./CalendarStyled";
import PropTypes from "prop-types";
import { useState } from "react";

const CalendarOnlyPicker = ({
  dual = false,
  startDate,
  endDate,
  selectedDate,
  onChange,
  type,
}) => {
  const [leftMonth, setLeftMonth] = useState(dayjs().subtract(1, "month"));
  const [rightMonth, setRightMonth] = useState(dayjs());

  const commonProps = {
    open: true,
    format: dateFormatList,
    getPopupContainer: () => document.querySelector(".calendar-only-modal"),
    allowClear: false,
    inputReadOnly: true,
  };

  const getDisabledDate = (
    current,
    type,
    minDate = dayjs().subtract(1, "year")
  ) => {
    const today = dayjs().endOf("day");

    if (!current) return false;

    switch (type) {
      case "today":
      case "yesterday":
      case "last_7_days":
      case "last_14_days":
        // disable everything because range is already selected
        return true;

      default:
        return current.isBefore(minDate) || current.isAfter(today);
    }
  };

  const renderDateCell = (current, startDate, endDate) => {
    const isStart = startDate && current.isSame(startDate, "day");
    const isEnd = endDate && current.isSame(endDate, "day");
    const isInRange =
      startDate &&
      endDate &&
      current.isAfter(startDate, "day") &&
      current.isBefore(endDate, "day");

    let className = "ant-picker-cell-inner";
    if (type !== "custom_date") {
      if (isStart && isEnd) className += " range-start-end";
      else if (isStart) className += " range-start";
      else if (isEnd) className += " range-end";
      else if (isInRange) className += " in-range";
    }

    return <div className={className}>{current.date()}</div>;
  };

  return (
    <CalendarWrapper className="calendar-only-modal">
      <Box>
        <CalendarComponent />
        <NotificationCalendarStyle />
        {dual ? (
          <>
            {/* Left calendar */}
            <StyledDatePicker
              {...commonProps}
              value={startDate}
              pickerValue={leftMonth}
              onPanelChange={(panelDate) => setLeftMonth(panelDate)}
              onChange={(date) => onChange?.(date)}
              disabledDate={(current) => getDisabledDate(current, type)}
              cellRender={(current) =>
                renderDateCell(current, startDate, endDate)
              }
            />

            {/* Right calendar */}
            <StyledDatePicker
              {...commonProps}
              value={endDate}
              pickerValue={rightMonth}
              onPanelChange={(panelDate) => setRightMonth(panelDate)}
              onChange={(date) => onChange?.(date)}
              disabledDate={(current) => getDisabledDate(current, type)}
              cellRender={(current) =>
                renderDateCell(current, startDate, endDate)
              }
            />
          </>
        ) : (
          <StyledDatePicker
            {...commonProps}
            value={selectedDate}
            onChange={(date) => onChange?.(date)}
            disabledDate={(current) => getDisabledDate(current, type)}
            cellRender={(current) =>
              renderDateCell(current, startDate, endDate)
            }
          />
        )}
      </Box>
    </CalendarWrapper>
  );
};

CalendarOnlyPicker.propTypes = {
  dual: PropTypes.bool,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  selectedDate: PropTypes.object,
  onChange: PropTypes.func,
  type: PropTypes.string,
};

export default CalendarOnlyPicker;
